// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"952f461e","149":"205b81f6","358":"43182fc3","513":"764a9a58","533":"f29b117d","662":"ad59eb7b"}[chunkId] + ".chunk.js";
};